import {grey500, grey600, grey800, white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    paper: {
        padding: 20,
        overflow: 'auto'
    },
    checkRemember: {
        style: {
            float: 'left',
            maxWidth: 180,
            paddingTop: 5
        },
        labelStyle: {
            color: grey500
        },
        iconStyle: {
            color: grey500,
            borderColor: grey500,
            fill: grey500
        }
    },
    loginBtn: {
        float: 'right'
    },
    btn: {
        background: '#4f81e9',
        color: white,
        padding: 7,
        borderRadius: 2,
        margin: 2,
        fontSize: 13
    },
    loginHeader: {
        row: {
            backgroundColor: white,
            marginRight: 0,
            marginLeft: 0
            //height: "100%"
             //gba(0, 0, 0, 0.12) 0px  rgba(0, 0, 0, 0.12) 0px 1px 4px
        },
        container: {
            //position: 'relative',
            //minHeight: 175
        },
        titleContainer: {
            paddingTop: 30,
            paddingBottom: 30,
            textAlign: 'left',
            marginTop: 'auto',
            marginBottom: 'auto'
        },
        title: {
            fontSize: 20,
            fontWeight: typography.fontWeightNormal,
            color: grey800
        },
        desc: {
            fontSize: 18,
            fontWeight: typography.fontWeightLight,
            color: grey600
        },
        image: {
            paddingTop: 30,
            maxHeight: 150,
            height: '100%'
        }
    },
    loginContainer: {
        minHeight: '100%',
        minWidth: 320,
        maxWidth: 400,
        height: 'auto',
        left: 0,
        right: 0,
        margin: '100px auto'
    },
    buttonsDiv: {
        textAlign: 'center',
        padding: 10
    },
    flatButton: {
        color: grey500
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/common/LoginPage/LoginPage.css.js